"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postVerifyToken = exports.postRefreshToken = exports.postAuthTokenGet = exports.useUserInfo = exports.postLogin = void 0;
const functions_1 = require("../functions");
// (account) 사용자 정보 조회
const getUserInfoData = async (props) => {
    const queryString = (0, functions_1.objectToQueryString)(props); // props를 쿼리 문자열로 변환
    const url = `/api/user/v1/users?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
// (account) 회원 계정
const postLogin = async (props) => {
    const url = `/api/user/v1/issue-auth-token`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Tenant-Id': props.partner_id,
        },
        body: JSON.stringify(props),
    });
};
exports.postLogin = postLogin;
// (account) 사용자 정보 조회 -useUserInfo
const useUserInfo = (data) => {
    return (0, functions_1.useCustomQuery)(['user', data], () => getUserInfoData(data));
};
exports.useUserInfo = useUserInfo;
// (account) 사용자 정보 조회 -useUserInfo
const postAuthTokenGet = async (props) => {
    const { partner_id, key, user_id } = props;
    const url = `/api/mimac/v1/partner/${partner_id}/ifAuthTokenGet`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-API-Key': key,
        },
        body: JSON.stringify({
            userId: user_id,
        }),
    });
};
exports.postAuthTokenGet = postAuthTokenGet;
// (account) 사용자 정보 조회 -useUserInfo
const postRefreshToken = async (props) => {
    const url = `/api/user/v1/refresh-auth-token`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(props),
    });
};
exports.postRefreshToken = postRefreshToken;
// (account) 사용자 정보 조회 -useUserInfo
const postVerifyToken = async (props) => {
    const url = `/api/user/v1/verify-auth-token`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(props),
    });
};
exports.postVerifyToken = postVerifyToken;
